import SpecificationsList from './SpecificationsList';

export default SpecificationsList;
